/**
 * Structured logging helpers for order confirmation CSV extraction debug.
 */

import { logInfo } from '../../config_and_helpers/logger';

/**
 * Build a compact, log-friendly snapshot of extracted order confirmation data.
 *
 * @param {import('../../types/orderConfirmationExtractionTypes').ExtractedOrderConfirmationData} data
 * @returns {Object}
 */
export function buildOrderConfirmationExtractionSnapshot(data) {
  if (!data) return { empty: true };

  return {
    supplier: data.supplier,
    order: data.order,
    totals: data.totals,
    itemCount: data.items?.length ?? 0,
    items: (data.items || []).map((item, index) => ({
      index,
      productNumber: item.productNumber,
      quantity: item.quantity,
      lineTotal: item.lineTotal,
      currency: item.currency,
      rawRowKeys: item.rawRow ? Object.keys(item.rawRow) : [],
    })),
    warnings: data.warnings,
    meta: data.meta,
  };
}

/**
 * @param {string} context
 * @param {string} message
 * @param {import('../../types/orderConfirmationExtractionTypes').ExtractedOrderConfirmationData} data
 * @param {Object} [extra]
 */
export function logOrderConfirmationExtraction(context, message, data, extra = {}) {
  logInfo(context, message, {
    ...extra,
    extraction: buildOrderConfirmationExtractionSnapshot(data),
  });
}
